import axios from 'axios'
import { set } from 'vue'

const getDefaultState = () => {
  return {
    data: [],
    totalElements: 0,
    currentPage: 1,
    filters: {
      macAddress: null,
      serialNumber: null,
      pseudoDeviceId: null,
      phone: null,
      ownerName: null,
      status: null,
      availability: null,
      manufacturer: null,
      modelName: null,
      warehouse: null
    }
  }
}

export default {
  //namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_DEVICES(state, data) {
      set(state, 'data', data)
    },
    SET_DEVICES_TOTAL(state, total) {
      state.totalElements = total
    },
    SET_CURRENT_PAGE(state, page) {
      state.currentPage = page
    },
    SET_DEVICES_FILTER_VALUE(state, { key, value }) {
      set(state.filters, key, value)
    },
    resetDevicesFilters(state) {
      set(state, 'filters', {
        macAddress: null,
        serialNumber: null,
        pseudoDeviceId: null,
        phone: null,
        ownerName: null,
        status: null,
        availability: null,
        manufacturer: null,
        modelName: null,
        warehouse: null
      })
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async getDevices({ state, commit }, payload) {
      const page = payload?.page || 1
      const limit = payload?.limit || 25

      let params = { page, limit }

      if (!payload?.ignoreFilters) {
        Object.entries(state.filters).forEach(([key, value]) => {
          if (value !== null && value !== undefined && value !== '') {
            params[key] = value
          }
        })
      }

      if (payload?.isRequest) {
        params.isRequest = 'true'
      }

      const res = await axios('/device/list', { params })
      commit('SET_DEVICES', res.data.content)
      commit('SET_DEVICES_TOTAL', res.data.elements)
      commit('SET_CURRENT_PAGE', page)
    },
    async addDevice({ dispatch }, data) {
      const res = await axios.post('/device', data)
      dispatch('getDevices')
      return res.status
    },
    async editDevice({ dispatch }, { id, data }) {
      const res = await axios.put(`/device/${id}`, data)
      dispatch('getDevices')
      return res.status
    },
    async bulkImportDevices({ dispatch }, data) {
      const res = await axios.post('/inventory/bulk/import', data)
      dispatch('getDevices')
      return res.data
    },
    async exportDevices({ state }) {
      const params = {}
      Object.entries(state.filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== '') {
          params[key] = value
        }
      })
      const res = await axios.get('/inventory/bulk/export', {
        maxBodyLength: Infinity,
        responseType: 'blob',
        params
      })
      const filename = res.headers['content-disposition'].split('filename=')[1]
      const link = document.createElement('a')
      const url = window.URL.createObjectURL(new Blob([res.data]))
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)

      link.click()

      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    },

    async syncDevices({ state }) {
      const params = { ...state.data }
      const res = await axios.post('cucm/devices/sync', {
        params
      })
      return res.status
    },

    async deleteAllDevices({ dispatch }, warehouseId) {
      const params = warehouseId ? { warehouseId } : {}
      await axios.delete('/device/all', { params })
      dispatch('getDevices', { page: 1 })
    },
    setDevicesFilterValue({ commit, dispatch }, { key, value }) {
      commit('SET_DEVICES_FILTER_VALUE', { key, value })
      dispatch('getDevices', { page: 1 })
    },
    resetDevicesFilters({ commit, dispatch }) {
      commit('resetDevicesFilters')
      dispatch('getDevices', { page: 1 })
    }
  }
}
